import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    jeePapersListLoading: false,
    jeePapersListSuccess: null,
    jeePapersListError: '',
    jeePaperScoreListLoading: false,
    jeePaperScoreListSuccess: null,
    jeePaperScoreListError: '',
    getjeeMarksLoading: false,
    getjeeMarksSuccess: {},
    getjeeMarksError: '',
    createjeeMarksLoading: false,
    createjeeMarksSuccess: {},
    createjeeMarksError: '',
    studentAcademicRecordListLoading: true,
    studentAcademicRecordListSuccess: null,
    studentAcademicRecordListError: '',
    termGoal: [],
    batches: [],
}

export const jeeMarksSlice = createSlice({
    name: 'jeeMarks',
    initialState,
    reducers: {
        setPapersListLoading: (state, action) => {
            state.jeePapersListLoading = true;
            state.jeePapersListSuccess = null;
            state.jeePapersListError = '';
        },
        setPapersListSuccess: (state, action) => {
            state.jeePapersListLoading = false;
            state.jeePapersListSuccess = action.payload;
            state.jeePapersListError = '';
        },
        setPapersListError: (state, action) => {
            state.jeePapersListLoading = false;
            state.jeePapersListSuccess = null;
            state.jeePapersListError = action.payload;
        },
        setPaperScoreListLoading: (state, action) => {
            state.jeePaperScoreListLoading = true;
            state.jeePaperScoreListSuccess = null;
            state.jeePaperScoreListError = '';
        },
        setPaperScoreListSuccess: (state, action) => {
            state.jeePaperScoreListLoading = false;
            state.jeePaperScoreListSuccess = action.payload;
            state.jeePaperScoreListError = '';
        },
        setPaperScoreListError: (state, action) => {
            state.jeePaperScoreListLoading = false;
            state.jeePaperScoreListSuccess = null;
            state.jeePaperScoreListError = action.payload;
        },
        setGetjeeMarksLoading: (state) => {
            state.getjeeMarksLoading = true;
            state.getjeeMarksSuccess = {};
            state.getjeeMarksError = '';
        },
        setGetjeeMarksSuccess: (state, action) => {
            state.getjeeMarksLoading = false;
            state.getjeeMarksSuccess = action.payload.data;
            state.getjeeMarksError = '';
        },
        setGetjeeMarksError: (state, action) => {
            state.getjeeMarksLoading = false;
            state.getjeeMarksSuccess = {};
            state.getjeeMarksError = action.payload;
        },
        setCreatejeeMarksLoading: (state) => {
            state.createjeeMarksLoading = true;
            state.createjeeMarksSuccess = {};
            state.createjeeMarksError = '';
        },
        setCreatejeeMarksSuccess: (state, action) => {
            state.createjeeMarksLoading = false;
            state.createjeeMarksSuccess = action.payload;
            state.createjeeMarksError = '';
        },
        setCreatejeeMarksError: (state, action) => {
            state.createjeeMarksLoading = false;
            state.createjeeMarksSuccess = {};
            state.createjeeMarksError = action.payload;
        },
        setStudentAcademicRecordLoading: (state, action) => {
            state.studentAcademicRecordListLoading = true;
            state.studentAcademicRecordListSuccess = null;
            state.studentAcademicRecordListError = '';
        },
        setStudentAcademicRecordSuccess: (state, action) => {
            state.studentAcademicRecordListLoading = false;
            state.studentAcademicRecordListSuccess = action.payload;
            state.studentAcademicRecordListError = '';
        },
        setStudentAcademicRecordError: (state, action) => {
            state.studentAcademicRecordListLoading = false;
            state.studentAcademicRecordListSuccess = null;
            state.studentAcademicRecordListError = action.payload;
        },
        setBatches: (state, action) => {
            state.batches = action.payload
        },
        resetJeeMarkDetails: (state, action) => {
            state.getjeeMarksSuccess = {};
            state.createjeeMarksSuccess = {}
        },
    },
})

export const {
    setCreatejeeMarksError, setPapersListLoading,
    setPapersListSuccess, setPapersListError,
    setPaperScoreListLoading, setPaperScoreListSuccess, setPaperScoreListError,
    setCreatejeeMarksLoading, setCreatejeeMarksSuccess,
    setGetjeeMarksLoading, setGetjeeMarksSuccess,
    setGetjeeMarksError,
    setStudentAcademicRecordLoading, setStudentAcademicRecordSuccess, setStudentAcademicRecordError,
    setBatches,
    resetJeeMarkDetails
} = jeeMarksSlice.actions

export default jeeMarksSlice.reducer;